'use strict'

import Axios from 'axios';
import configuration from "../../configuration";

const url = configuration.apiHost;

export default class OfficceService {

  static async getAll() {
    try {
      let officces = await Axios.get(url + "offices");
      return officces.data;
    } catch (error) {
      throw error.response.data;
    }
  } // getAll()

  static async getByName(description){
    try {
      
      let officces = await Axios.get(url + `offices/${description}`);
      return officces.data;
    } catch (error) {
      throw error.response.data;
    }
  }

  static async save(officce) {
    try {
      let officceSaved = await Axios.post(url + "offices", officce);
      return officceSaved.data;
    } catch (error) {
      throw error.response.data;
    }
  } // save()

  static async update(officce) {
    try {
      let officceUpdated = await Axios.put(url + "offices", officce);
      return officceUpdated.data;
    } catch (error) {
      throw error.response.data;
    }
  } // update()

  static async remove(officce) {
    try {
      await Axios.delete(url + "offices", {
        data: officce
      });
    } catch (error) {
      throw error.response.data;
    }
  } // remove()
} // class



// WEBPACK FOOTER //
// ./src/service/OfficceService.js